import * as React from "react";
import { useEffect, useState } from "react";
import { styled } from "@mui/material";
import { QualifiedFeatureFragment } from "fe-common/graphql";
import { organsSystemIcons } from "fe-common/ui/oranSystemIcons";
import { MobileView } from "../../util/aKaunGeneralUtil";
import clsx from "clsx";
import { CommonColors } from "fe-web-components/colors/commonColors";

//region [[ Styles ]]

const OrganSystemIconView = styled("div")(({ theme }: { theme?: any }) => ({
  display: "inline",
  padding: "8px",
  borderRadius: "50%",
  opacity: 0.8,
  background: CommonColors.IconBackground,
  margin: "0 5px",
}));

const IconContainer = styled("div")(
  ({
    theme,
    margintop,
    loading,
  }: {
    theme?: any;
    margintop: number;
    loading: string;
  }) => ({
    alignItems: "center",
    width: "32px",
    height: "33px",
    display: "flex",
    justifyContent: "center",
    fontSize: "26px",
    [theme.breakpoints.down(MobileView)]: {
      fontSize: "26px",
    },
    color: CommonColors.Primary,
    paddingTop: margintop !== undefined ? margintop : "4px",
    opacity: loading === "true" ? 0 : 1,
  }),
);

//endregion [[ Styles ]]

//region [[ Props ]]

export interface OrganSystemIconProps {
  feature: QualifiedFeatureFragment;
  showBackground: boolean;
  loading?: boolean;
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const OrganSystemIcon = ({ ...props }: OrganSystemIconProps) => {
  const [icon, setIcon] = useState<null | any>(null);
  const [marginTop, setMarginTop] = useState<null | any>(0);

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    const organSystem = props.feature.feature
      ? props.feature.feature.organSystem
      : null;
    if (organSystem && organsSystemIcons()[organSystem.id]) {
      setIcon(organsSystemIcons()[organSystem.id].icon);
      setMarginTop(organsSystemIcons()[organSystem.id].marginTop);
    } else {
      setIcon(<i className="fad fa-bullseye" />);
      setMarginTop(2);
    }
  }, [props.feature.feature]);

  return (
    <OrganSystemIconView className={clsx("organ-system-icon", props.className)}>
      <IconContainer
        margintop={marginTop}
        loading={props.loading ? "true" : " false"}
      >
        {icon ? icon : <i className="fad fa-bullseye" />}
      </IconContainer>
    </OrganSystemIconView>
  );
};
